import { Component, OnInit, ViewChild } from '@angular/core';
import { FRdv } from '../model/FRdv';
import {TableModule} from 'primeng/table';
import { AuthService } from '../providers/auth.service';
import { UsersService } from '../services/users.service';
import { RdvService } from '../services/rdv.service';
import { Observable } from 'rxjs';
import * as firebase from 'firebase/app';
import { DatePipe } from '@angular/common';
import {TabMenuModule} from 'primeng/tabmenu';
import {MenuItem} from 'primeng/api';
import { DataTableModule } from 'primeng/primeng'; // Here
import { PaginatorModule } from 'primeng/primeng'; // Here
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [DatePipe]
})
export class DashboardComponent implements OnInit {

  private _opened: boolean = false;
  @ViewChild('menuItems') menu: MenuItem[];
  private loginUser = "";

  public idToDelete:Number;
 
  items: MenuItem[];
  
    
  activeItem: MenuItem;

  first = 0;

    rows = 10;

    display: boolean = false;
    myCount: number = 10;
    countChange(event) {
      this.refreshData();
    }

    deleteRdv(idRdv) {
    
        this.idToDelete = idRdv;
        this.display = true;
        
    }

    confirmeDeleteRdv()
    {


      firebase.auth().onAuthStateChanged((userFire:firebase.User) => {
        if (userFire) {
            firebase.auth().currentUser.getIdToken(true).then((idToken) => {
               var ret :Observable<Boolean> = this.rdvService.deleteRdv(idToken, userFire.uid, this.idToDelete );
                ret.subscribe(reee => { 
                  console.log(reee)
                  this.refreshData();
                  this.closeDialog();
                })

                
            })
        }
      })


    }

    closeDialog()
    {
      this.display = false;
      this.idToDelete = null;
    }

    refreshData(){

      firebase.auth().onAuthStateChanged((userFire:firebase.User) => {
        if (userFire) {
            firebase.auth().currentUser.getIdToken(true).then((idToken) => {
                let site:number = Number(this.activeItem.id);
                this.rdvss = this.rdvService.getRdv(idToken, userFire.uid, site);
                this.rdvss.subscribe(rdv => { 
                  this.rdvs = rdv;
       
              
                  this.updateRowGroupMetaData();
            
            })
          })
        }
      })


    }

  private _toggleSidebar() {
    this._opened = !this._opened;
  }

  public rightValidated : Observable<boolean>;


  cols: any[];


  rowGroupMetadata = {};

  rdvss : Observable<FRdv[]>; 
  rdvs: FRdv[];

  constructor(private authService: AuthService, private usersService: UsersService, private rdvService: RdvService, private datePipe: DatePipe) { }

  next() {
    this.first = this.first + this.rows;
}

prev() {
    this.first = this.first - this.rows;
}

reset() {
    this.first = 0;
}

isLastPage(): boolean {
    return this.first === (this.rdvs.length - this.rows);
}

isFirstPage(): boolean {
    return this.first === 0;
}


activateMenu(){
  this.activeItem =this.menu['activeItem'];
  this.refreshData();
}

  ngOnInit() {

    this.items = [
      {label: 'Villeneuve d\'Ascq', id:'1', icon: 'pi pi-fw pi-home'},
      {label: 'Denain',  id:'2', icon: 'pi pi-fw pi-home'},
      {label: 'Arras',  id:'3', icon: 'pi pi-fw pi-home'}
  ];
  
  this.activeItem = this.items[0];
  
    firebase.auth().onAuthStateChanged((userFire:firebase.User) => {
      if (userFire) {
        firebase.auth().currentUser.getIdToken(true).then((idToken) => {


          this.rightValidated = this.usersService.checkUserRight(idToken, userFire.uid);
          this.rightValidated.subscribe((response: boolean) =>  {
          
            
              if(response == true)
              {
                
                this.initApp();
              }
              else{
                //this.authService.logout();
                window.location.href = "https://localhost:4200/login";
              }

          });
        })
      }
    })

  }

  private initApp(){

    this.refreshData();

    firebase.auth().onAuthStateChanged((userFire:firebase.User) => {
      if (userFire) {
          firebase.auth().currentUser.getIdToken(true).then((idToken) => {
            this.loginUser = userFire.email;
        })
      }
    })

  }

  onSort() {
    this.updateRowGroupMetaData();
  }

  updateRowGroupMetaData() {
    this.rowGroupMetadata = {};
    if (this.rdvs) {
      for (let i = 0; i < this.rdvs.length; i++) {
        let rowData = this.rdvs[i];
        this.rdvs[i].dateCreneau = this.datePipe.transform(rowData.fcreneaux.dateCreneau, 'yyyy-MM-dd');
        let idRdv = this.datePipe.transform(rowData.fcreneaux.dateCreneau, 'yyyy-MM-dd');
       
        //let idRdv = rowData.immatriculation;
        if (i == 0) {
          this.rowGroupMetadata[idRdv] = { index: 0, size: 1 };
        }
        else {
          let previousRowData = this.rdvs[i - 1];
          let previousRowGroup =  this.datePipe.transform(previousRowData.fcreneaux.dateCreneau, 'yyyy-MM-dd');
          //let previousRowGroup = previousRowData.immatriculation;
          if (idRdv === previousRowGroup)
            this.rowGroupMetadata[idRdv].size++;
          else
            this.rowGroupMetadata[idRdv] = { index: i, size: 1 };
        }
      }
     
    }
  }

  onFilter(event) {
    this.updateRowGroupMetaDataFilter(event.filteredValue);
  }

  updateRowGroupMetaDataFilter(data) {
    this.rowGroupMetadata = {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let idRdv = this.datePipe.transform(rowData.fcreneaux.dateCreneau, 'yyyy-MM-dd');
        //let idRdv = rowData.immatriculation;
        if (i == 0) {
          this.rowGroupMetadata[idRdv] = { index: 0, size: 1 };
        }
        else {
          let previousRowData = this.rdvs[i - 1];
          let previousRowGroup =  this.datePipe.transform(previousRowData.fcreneaux.dateCreneau, 'yyyy-MM-dd');
          // let previousRowGroup = previousRowData.immatriculation;
          if (idRdv === previousRowGroup)
            this.rowGroupMetadata[idRdv].size++;
          else
            this.rowGroupMetadata[idRdv] = { index: i, size: 1 };
        }
      }
    }
  }

}
